import {BookingsHttp} from "../../../http/BookingsHttp";

export default {
    async setBookings({commit}, day) {
        const bookings = await BookingsHttp.getBookingsByDay(day).then(result => result.data);
        commit('setBookings', bookings.bookings);
        if (bookings.value.length > 0) {
            commit('setDailyValue', bookings.value[0].totalValue)
        } else {
            commit('setDailyValue', 0)
        }

        if (bookings.sales.length > 0) {
            commit('setDailySales', bookings.sales[0].totalValue)
        } else {
            commit('setDailySales', 0)
        }
        if (bookings.sales.length > 0) {
            commit('setDailySalesBookings', bookings.sales[0].documents)
        } else {
            commit('setDailySalesBookings', [])
        }
        commit('setReschedule', bookings.rescheduleOnly);
        commit('setCancellation', bookings.cancelOnly);
        commit('setEntries', bookings.entries);
    },
    async setCumulative({commit}, day) {
      const data = await BookingsHttp.fetchCumulativeTotals(day).then(res => res.data);
      commit('setCumulative', data);
    },
    setActiveBooking({commit}, activeBooking) {
        commit('setActiveBooking', activeBooking);
    },
    setManageBookingDialog({commit}, status) {
        commit('setManageBookingDialog', status);
    },
    setManageDeleteBookingDialog({commit}, status) {
       commit('setManageDeleteBookingDialog', status);
    },
    setPreviewJobDialog({commit}, status) {
       commit('setPreviewJobDialog', status);
    }
}
